<template>
	<section class="wrapper--login" id="validateEmail">

		<!-- TEXTO COM MAIS DE 24H do envio anterior ================ -->
		<div id="over__24" v-if="messageType === 'over24'" data-qa="email-validation-resend-ready-alert">
			<hgroup>
				<h1>{{ $t('validation.valid01.title') }}</h1>
				<p>{{ $t('validation.valid01.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid01.description')"></p>
		</div>


		<!-- TEXTO COM MENOS DE 24H do envio anterior ================ -->
		<div id="under__24" v-if="messageType === 'under24'" data-qa="email-validation-resend-cooldown-alert">
			<hgroup>
				<h1>{{ $t('validation.valid02.title') }}</h1>
				<p>{{ $t('validation.valid02.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid02.description')"></p>
		</div>


		<!-- Email EXPIRADO ================ -->
		<div id="expired" v-if="messageType === 'expired'" data-qa="email-validation-expired-alert">
			<hgroup>
				<h1>{{ $t('validation.valid03.title') }}</h1>
				<p>{{ $t('validation.valid03.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid03.description')"></p>
		</div>
		<!-- Email EXPIRADO ================ -->

		<!-- Frase feedback de reenvio de email -->
		<p class="box__validateEmail" v-html="$t('validation.feedback')" v-if="feedback" data-qa="email-validation-resend-success"></p>

		
		<!-- BLOCO 4: Feedback para e-mail já validado 
		###################################################################################################
		
		Para esse modulo exibir somente o botão de "voltar" e retirar o botão de reenviar e-mail de validação 
		
		================================================================================================  
		-->
		<div id="feedback-email-validated" v-if="messageType === 'validated'" data-qa="email-validation-confirmed-success">
			<hgroup>
				<h1>{{ $t('validation.valid04.title') }}</h1>
				<p>{{ $t('validation.valid04.subtitle') }}</p>
			</hgroup>
			<p class="box__validateEmail" v-html="$t('validation.valid04.description')"></p>
		</div>
		
		<!-- Mensagem adicional de feedback para reenvio de e-mail -->
		<p class="box__validateEmail" v-html="$t('validation.feedback')" v-if="false"></p>
		<!-- Botões de ação -->

		<div class="row buttons--wrap">
			<AppButton variant="secondary" @click="$emit('voltar')" data-qa="email-validation-back-button">{{ $t('buttons.voltar') }}</AppButton>
				<AppButton v-show="messageType === 'expired' || messageType === 'over24'" variant="primary"
					data-qa="email-validation-resend-button"
					:disabled="isResending"
					@click="$emit('reenviar')">{{ $t('buttons.resendValidationEmail') }}</AppButton>
		</div>

	</section>
</template>

<script>
import AppButton from '@/components/ui/AppButton.vue'

export default {
	name: 'ValidateMail',
	components: {
		AppButton,

	},
	props: {
		messageType: {
			type: String,
			required: true, // 'over24', 'under24', 'expired', 'validated'
		},
		feedback: {
			type: Boolean,
			required: true, //  'feedback'
		},
		isResending: {
			type: Boolean,
			default: false
		}
	},
	mounted() {

	},
	watch: {

	},
	methods: {

	},
}
</script>

<style lang="sass" scoped>
@use '../assets/sass/utilities/_colors' as *
@use '../assets/sass/utilities/_responsive' as *

.wrapper--login

	hgroup
		h1
			font-weight: 700
			font-size: clamp( 1.40rem, var(--clamp), 2rem)
		
		p
			font-size: 1rem


	.buttons--wrap
		margin-top: 2rem
		display: flex
		flex-direction: row
		gap: 1rem
		align-items: center
		justify-content: center

#validateEmail
	.box__validateEmail
		margin-block: 2rem
		background-color: rgba(var(--lg-mid-gray-100-rgb), 0.3)
		border: 1px solid rgba(var(--lg-mid-gray-100-rgb), 0.3)
		padding: 1.2rem
		font-weight: 600
		border-radius: 1rem

		p
			text-wrap: balance

</style>
